import _definePage_default_0 from 'D:/xampp/htdocs/farmoptim/resources/js/pages/forgot-password.vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from 'D:/xampp/htdocs/farmoptim/resources/js/pages/login.vue?definePage&vue'
import _definePage_default_3 from 'D:/xampp/htdocs/farmoptim/resources/js/pages/login-old.vue?definePage&vue'
import _definePage_default_4 from 'D:/xampp/htdocs/farmoptim/resources/js/pages/not-authorized.vue?definePage&vue'
import _definePage_default_5 from 'D:/xampp/htdocs/farmoptim/resources/js/pages/register.vue?definePage&vue'
import _definePage_default_6 from 'D:/xampp/htdocs/farmoptim/resources/js/pages/s/[id].vue?definePage&vue'
import _definePage_default_7 from 'D:/xampp/htdocs/farmoptim/resources/js/pages/s/identify/[id].vue?definePage&vue'
import _definePage_default_8 from 'D:/xampp/htdocs/farmoptim/resources/js/pages/s/text/[id].vue?definePage&vue'
import _definePage_default_9 from 'D:/xampp/htdocs/farmoptim/resources/js/pages/settings/identity.vue?definePage&vue'
import _definePage_default_10 from 'D:/xampp/htdocs/farmoptim/resources/js/pages/settings/sessionPublic.vue?definePage&vue'
import _definePage_default_11 from 'D:/xampp/htdocs/farmoptim/resources/js/pages/settings/text.vue?definePage&vue'

export const routes = [
  {
    path: '/farm',
    /* internal name: 'farm' */
    /* no component */
    children: [
      {
        path: 'avatars',
        /* internal name: 'farm-avatars' */
        /* no component */
        children: [
          {
            path: '',
            name: 'farm-avatars',
            component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/farm/avatars/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'bots',
        name: 'farm-bots',
        component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/farm/bots.vue'),
        /* no children */
      },
      {
        path: 'campaigns',
        /* internal name: 'farm-campaigns' */
        /* no component */
        children: [
          {
            path: '',
            name: 'farm-campaigns',
            component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/farm/campaigns/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'farm-campaigns-id',
            component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/farm/campaigns/[id].vue'),
            /* no children */
          },
          {
            path: 'activity',
            name: 'farm-campaigns-activity',
            component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/farm/campaigns/activity.vue'),
            /* no children */
          },
          {
            path: 'activity - Copy',
            name: 'farm-campaigns-activity  copy',
            component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/farm/campaigns/activity - Copy.vue'),
            /* no children */
          },
          {
            path: 'create',
            name: 'farm-campaigns-create',
            component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/farm/campaigns/create.vue'),
            /* no children */
          },
          {
            path: 'form',
            name: 'farm-campaigns-form',
            component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/farm/campaigns/form.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'categories',
        /* internal name: 'farm-categories' */
        /* no component */
        children: [
          {
            path: '',
            name: 'farm-categories',
            component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/farm/categories/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'proxies',
        /* internal name: 'farm-proxies' */
        /* no component */
        children: [
          {
            path: '',
            name: 'farm-proxies',
            component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/farm/proxies/index.vue'),
            /* no children */
          },
          {
            path: 'AllocateProxiesModal',
            name: 'farm-proxies-allocate-proxies-modal',
            component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/farm/proxies/AllocateProxiesModal.vue'),
            /* no children */
          },
          {
            path: 'BatchHealthCheckDialog',
            name: 'farm-proxies-batch-health-check-dialog',
            component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/farm/proxies/BatchHealthCheckDialog.vue'),
            /* no children */
          },
          {
            path: 'BulkImportModal',
            name: 'farm-proxies-bulk-import-modal',
            component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/farm/proxies/BulkImportModal.vue'),
            /* no children */
          },
          {
            path: 'PolicySettingsModal',
            name: 'farm-proxies-policy-settings-modal',
            component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/farm/proxies/PolicySettingsModal.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'read-results',
        name: 'farm-read-results',
        component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/farm/read-results.vue'),
        /* no children */
      },
      {
        path: 'sessions',
        /* internal name: 'farm-sessions' */
        /* no component */
        children: [
          {
            path: '',
            name: 'farm-sessions',
            component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/farm/sessions/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'farm-sessions-id',
            component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/farm/sessions/[id].vue'),
            /* no children */
          },
          {
            path: 'create',
            name: 'farm-sessions-create',
            component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/farm/sessions/create.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'sessionsCreate-bk',
        name: 'farm-sessions-create-bk',
        component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/farm/sessionsCreate-bk.vue'),
        /* no children */
      },
      {
        path: 'users',
        /* internal name: 'farm-users' */
        /* no component */
        children: [
          {
            path: '',
            name: 'farm-users',
            component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/farm/users/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'farm-users-id',
            component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/farm/users/[id].vue'),
            /* no children */
          },
          {
            path: 'create',
            name: 'farm-users-create',
            component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/farm/users/create.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/forgot-password.vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/login.vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  _mergeRouteRecord(
  {
    path: '/login-old',
    name: 'login-old',
    component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/login-old.vue'),
    /* no children */
  },
  _definePage_default_3
  ),
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_4
  ),
  _mergeRouteRecord(
  {
    path: '/register',
    name: 'register',
    component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/register.vue'),
    /* no children */
  },
  _definePage_default_5
  ),
  {
    path: '/s',
    /* internal name: 's' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'sid',
        component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/s/[id].vue'),
        /* no children */
      },
  _definePage_default_6
  ),
      {
        path: 'identify',
        /* internal name: 'sidentify' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'sidentify-id',
            component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/s/identify/[id].vue'),
            /* no children */
          },
  _definePage_default_7
  )
        ],
      },
      {
        path: 'text',
        /* internal name: 'stext' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'stext-id',
            component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/s/text/[id].vue'),
            /* no children */
          },
  _definePage_default_8
  )
        ],
      }
    ],
  },
  {
    path: '/settings',
    /* internal name: 'settings' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'identity',
        name: 'settings-identity',
        component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/settings/identity.vue'),
        /* no children */
      },
  _definePage_default_9
  ),
      {
        path: 'logs',
        name: 'settings-logs',
        component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/settings/logs.vue'),
        /* no children */
      },
  _mergeRouteRecord(
      {
        path: 'sessionPublic',
        name: 'settings-session-public',
        component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/settings/sessionPublic.vue'),
        /* no children */
      },
  _definePage_default_10
  ),
      {
        path: 'settings',
        name: 'settings-settings',
        component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/settings/settings.vue'),
        /* no children */
      },
  _mergeRouteRecord(
      {
        path: 'text',
        name: 'settings-text',
        component: () => import('D:/xampp/htdocs/farmoptim/resources/js/pages/settings/text.vue'),
        /* no children */
      },
  _definePage_default_11
  )
    ],
  }
]
